/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Card_Support_TitleInputs */

const en_contact_card_support_title = /** @type {(inputs: Contact_Card_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact support`)
};

const es_contact_card_support_title = /** @type {(inputs: Contact_Card_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactar soporte`)
};

/**
* | output |
* | --- |
* | "Contact support" |
*
* @param {Contact_Card_Support_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const contact_card_support_title = /** @type {((inputs?: Contact_Card_Support_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Card_Support_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_card_support_title(inputs)
	return en_contact_card_support_title(inputs)
});